import * as address from './address';
import * as insurance from './insurance';
import * as mapping from './mapping';
import * as professional from './professional';
import * as webhook from './webhook';

export default {
  address,
  insurance,
  mapping,
  professional,
  webhook,
};
